import { useEffect, useState } from 'react';

/**
 * Devuelve `value` con un retraso de `delay` ms desde el último cambio.
 * Útil para no disparar trabajo pesado (filtrar/buscar) en cada tecla.
 */
export default function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
